import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Industries } from './pages/Industries';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/services" element={<Services data-id="element-6" />} data-id="element-5" />
          <Route path="/industries" element={<Industries data-id="element-8" />} data-id="element-7" />
          <Route path="/about" element={<About data-id="element-10" />} data-id="element-9" />
          <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
          <Route path="/terms" element={<Terms data-id="element-14" />} data-id="element-13" />
          <Route path="/privacy" element={<Privacy data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Layout>
    </Router>;
}